var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedInCircle = function SvgLinkedInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedInCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0a9.962 9.962 0 0 0-7.067 2.933A9.962 9.962 0 0 0 0 10a9.962 9.962 0 0 0 2.933 7.067A9.962 9.962 0 0 0 10 20a9.962 9.962 0 0 0 7.067-2.933A9.962 9.962 0 0 0 20 10c0-5.524-4.476-10-10-10ZM6.81 15.581H4.314V8.057H6.81v7.524ZM6.6 6.657c-.267.248-.61.372-1.038.372h-.01c-.41 0-.742-.124-1-.372a1.242 1.242 0 0 1-.38-.933c0-.372.123-.686.39-.934.257-.238.6-.361 1.019-.361.419 0 .752.123 1.01.361.257.248.39.572.39.962 0 .362-.124.667-.381.905Zm9.229 8.924h-2.496v-4.029c0-1.133-.419-1.695-1.257-1.695-.324 0-.6.086-.81.267-.209.171-.37.39-.476.647-.066.143-.095.343-.095.6v4.21H8.2c.01-2.276.02-4.029.02-5.286-.001-1.257-.01-2-.02-2.238h2.495v1.067c.543-.829 1.296-1.248 2.267-1.248.867 0 1.562.286 2.086.857.523.581.78 1.42.78 2.534v4.314Z",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedInCircle_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  })))));
};
export default SvgLinkedInCircle;